import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper';
import { RequestInfoModal } from './RequestInfoModal';


export default () => {
  const [modalOpened, setModalOpened] = useState(false);
  const { smBanners } = useSelector((state: IReduxState) => state.home);

  const handleClickSlide = (slide) => {
    const { openInNewTab, onClickUrl } = slide;

    if (onClickUrl) {
      window.open(onClickUrl, openInNewTab ? '_blank' : '_self');
    } else {
      setModalOpened(true);
    }
  };

  return (
    <>
      <Swiper
        modules={[Navigation, Autoplay]}
        navigation
        loop
        autoplay={{
          delay: 7000
        }}
        className="border-radius-8"
      >
        {smBanners.map((slide) => {
          const {_id, enabled, image} = slide;

          if (!enabled) {
            return null;
          }

          return (
            <SwiperSlide key={_id}>
              <img
                className="cursor-pointer"
                src={image}
                alt={'Shopmanager Banner'}
                onClick={() => handleClickSlide(slide)}
              />
            </SwiperSlide>
          );
        })
        }
      </Swiper>
      <RequestInfoModal isOpened={modalOpened} handleClose={() => setModalOpened(false)} />
    </>
  );
};
